var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHomeMoney = function SvgHomeMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 50,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home-money_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 19.89c0-.474.216-.921.586-1.216L23.03.774a1.556 1.556 0 0 1 1.94 0l22.444 17.9c.37.295.586.742.586 1.216v28.554c0 .86-.696 1.556-1.556 1.556H1.556C.696 50 0 49.304 0 48.444z"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#home-money_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 19.89c0-.474.216-.921.586-1.216L23.03.774a1.556 1.556 0 0 1 1.94 0l22.444 17.9c.37.295.586.742.586 1.216v28.554c0 .86-.696 1.556-1.556 1.556H1.556C.696 50 0 49.304 0 48.444z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m25.812 31.63 2.51 8.37h3.526l2.282-8.37h3.97V29h-3.253l2.182-8h-2.712l-2.13 8h-4.155l-2.13-8h-3.585l-2.13 8h-4.155l-2.13-8h-2.713l2.182 8H10.1v2.63h3.988L16.371 40h3.524l2.511-8.37zm-.79-2.63-.913-3.046L23.195 29zm3.71 2.63 1.377 5.171 1.377-5.171zm-9.246 0-1.377 5.171-1.377-5.171z",
    clipRule: "evenodd"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "home-money_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v50H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "home-money_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v50H0z"
  })))));
};
export default SvgHomeMoney;